<template>
	<el-dialog
		title="自动同意售后原因配置"
		:visible.sync="visible"
		left
		@close="handlerCancel"
	>
		<div class="dialog-body">
			<el-checkbox-group v-model="auto_refund_reason">
				<el-checkbox :label="item" v-for="(item,index) in list"></el-checkbox>
			</el-checkbox-group>
		</div>
		<span slot="footer" class="dialog-footer">
	      <el-button @click="handlerCancel">取 消</el-button>
	      <el-button type="primary" @click="handlerConfirm">保存</el-button>
	    </span>
	</el-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
	data() {
		return {
			current_id: null,
			userinfo: 1,
			visible: false,
			list: [],
			params: {},
			func: {},
			callback: {},
			shop_id: null,
			auto_refund_reason: [],
		}
	},
	computed: {
		...mapState({
			users: (state) => state.login.userinfo,
		}),
	},
	mounted() {
		
	},
	methods: {
		...mapActions({
			getUserinfoData: "login/getUserinfoData"
		}),
		open(params, func, callback) {
			this.params = params;
			this.func = func;
			this.callback = callback
			this.visible = true;
			if (this.users) {
				this.refreshUserinfo()
				console.log('userinfo', this.userinfo)
				
			}
		},
		refreshUserinfo() {
			this.getUserinfoData({
				data: {}, success: (res) => {
					this.userinfo = res.data
					this.list = this.userinfo.aftersale_reason_list
					this.auto_refund_reason = this.userinfo.auto_refund_reason
				}
			})
		},
		handlerConfirm() {
			this.func({
				data: {auto_refund_reason: this.auto_refund_reason},
				success: (res) => {
					this.callback(res);
					this.visible = false;
				},
			})
		},
		handlerCancel() {
			this.visible = false;
		}
	}
}
</script>

<style scoped>
:deep(.el-dialog) {
	width: 400px;

}

:deep(.el-checkbox__label) {
	font-size: 16px;
}
:deep(.el-checkbox){
	height: 30px;
}
</style>